import { LovValues } from '../../models/template.model';

export const getRegularOrColloquialVal = (value: string | string[], lovData: LovValues[]): string | string[] => {
  if (Array.isArray(value)) {
    return value.map(val => {
      const findMatchingLovObj =
        lovData != null && val != null ? lovData.find(data => data.key.toLowerCase() === val.toLowerCase()) : null;
      return findMatchingLovObj ? findMatchingLovObj.value : val;
    });
  } else {
    const findMatchingLovObj =
      lovData != null && value != null ? lovData.find(data => data.key.toLowerCase() === value.toLowerCase()) : null;
    return findMatchingLovObj ? findMatchingLovObj.value : value;
  }
};

export const TemplateLovAttributesReqPayload = {
  1064: ['LEED', 'Green'],
};
